import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chart_type_bar",
  "use": "chart_type_bar-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol viewBox=\"0 0 20 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chart_type_bar\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.46618 4.74365H4.49951V16.5385V17.5214H5.46618H16.0995V16.5385H5.46618V4.74365Z\" fill=\"black\" />\n<rect x=\"7.39941\" y=\"8.67529\" width=\"0.966667\" height=\"8.84615\" fill=\"black\" />\n<rect x=\"13.1995\" y=\"6.70947\" width=\"0.966666\" height=\"10.812\" fill=\"black\" />\n<rect x=\"10.2996\" y=\"11.624\" width=\"0.966667\" height=\"5.89744\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol